import React from "react";

function CreateProjectBlueprintBtn({ accountSlug, projectId, component }) {
  return (
    <button
      type="button"
      className="btn btn-success createProjectBlueprintBtn"
      onClick={() => window.location.assign(`/projects/${projectId}/sow_blueprints/new`)}
    >
      <i className="fa fa-sitemap"></i> Create Project Blueprint
    </button>
  );
}

export default CreateProjectBlueprintBtn;
